import { useState, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import Dialog from './Dialog';

const IncidendesFinancieresGlobalOperations = ({
    anneeDebut,
    setAnneeDebut,
    anneeFin,
    setAnneeFin,
    onValider,
    user
}) => {
    const green = '#59B44A';
    const purple = '#6571FE';
    const blue = '#069BD3';
    const [consolidatedData, setConsolidatedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    const fieldsList = [
        { label: 'Prix d\'acquisition (A)', key: 'sum_prix_acquisition', isBold: false, isCalculated: false },
        { label: 'Frais d\'actes (F)', key: 'sum_frais_actes', isBold: false, isCalculated: false },
        { label: 'Subventions (SUB)', key: 'sum_subventions', isBold: false, isCalculated: false },
        { label: 'Montant rétrocessions (RETRO)', key: 'sum_montant_retrocessions', isBold: false, isCalculated: false },
        { label: 'Total annuel - capital porté (ST1)', key: 'sum_total_annuel_capital_porte', isBold: true, isCalculated: true },
        { label: 'Frais préalables (FP)', key: 'sum_frais_prealables', isBold: false, isCalculated: false },
        { label: 'Frais annexes (FA)', key: 'sum_frais_annexes', isBold: false, isCalculated: false },
        { label: 'Frais GEGR (GEGR)', key: 'sum_frais_gegr', isBold: false, isCalculated: false },
        { label: 'Frais proto-aménagement (PROTO)', key: 'sum_frais_proto_amenagement', isBold: false, isCalculated: false },
        { label: 'Total annuel - hors capital porté (ST2)', key: 'sum_total_annuel_hors_capital_porte', isBold: true, isCalculated: true },
        { label: '', key: 'empty_1', isEmpty: true },
        { label: 'Annués sur le capital porté (AKP)', key: 'sum_annuites_capital_porte', isBold: false, isCalculated: true },
        { label: 'Ajustement éventuels des annués (AJ)', key: 'sum_ajustement_annuites', isBold: false, isCalculated: false },
        { label: 'Annué hors capital porté (AHKP)', key: 'sum_annuite_hors_capital_porte', isBold: false, isCalculated: true },
        { label: 'Annué définitive à facturer (AT)', key: 'sum_annuite_definitive', isBold: true, isCalculated: true },
        { label: '', key: 'empty_2', isEmpty: true },
        { label: 'TOTAL - capital stocké au 31/12 (KS)', key: 'sum_capital_stocke', isBold: true, isCalculated: true },
        { label: '', key: 'empty_3', isEmpty: true },
        { label: 'Total capital porté au 31/12 (CFP)', key: 'sum_calcul_frais_portage', isBold: false, isCalculated: true },
        { label: 'Frais de portage HT (FPHT)', key: 'sum_frais_portage_ht', isBold: false, isCalculated: true },
        { label: 'TVA sur frais de portage 20% (TVA)', key: 'sum_tva_frais_portage', isBold: false, isCalculated: true },
        { label: 'Frais de portage TTC (FPTTC)', key: 'sum_frais_portage_ttc', isBold: true, isCalculated: true },
        { label: '', key: 'empty_4', isEmpty: true },
        { label: 'Entretien réparations (ER)', key: 'sum_entretien_reparations', isBold: false, isCalculated: false },
        { label: 'Eau/électricité (DEE)', key: 'sum_eau_electricite', isBold: false, isCalculated: false },
        { label: 'Charges de copropriété (DCC)', key: 'sum_charges_copropriete', isBold: false, isCalculated: false },
        { label: 'Taxes foncières (DTFB)', key: 'sum_taxes_foncieres', isBold: false, isCalculated: false },
        { label: 'Taxe/redevance OM (DOM)', key: 'sum_taxe_redevance_om', isBold: false, isCalculated: false },
        { label: 'Assurances (DASS)', key: 'sum_assurances', isBold: false, isCalculated: false },
        { label: 'Autres (DAU)', key: 'sum_autres_depenses', isBold: false, isCalculated: false },
        { label: 'TOTAL Dépenses (TOTDEP)', key: 'sum_total_depenses', isBold: true, isCalculated: true },
        { label: '', key: 'empty_5', isEmpty: true },
        { label: 'Loyers perçus (LOY)', key: 'sum_loyers_percus', isBold: false, isCalculated: false },
        { label: 'Refacturation - Eau/électricité (REE)', key: 'sum_refacturation_eau_electricite', isBold: false, isCalculated: false },
        { label: 'Refacturation - Charges de copropriété (RCC)', key: 'sum_refacturation_charges_copropriete', isBold: false, isCalculated: false },
        { label: 'Refacturation - Taxes foncières (RTFB)', key: 'sum_refacturation_taxes_foncieres', isBold: false, isCalculated: false },
        { label: 'Refacturation - OM (ROM)', key: 'sum_refacturation_om', isBold: false, isCalculated: false },
        { label: 'Refacturation - Assurances (RASS)', key: 'sum_refacturation_assurances', isBold: false, isCalculated: false },
        { label: 'Autres (RAU)', key: 'sum_autres_recettes', isBold: false, isCalculated: false },
        { label: 'TOTAL Recettes (TOTREC)', key: 'sum_total_recettes', isBold: true, isCalculated: true },
        { label: '', key: 'empty_6', isEmpty: true },
        { label: 'Solde annuel frais de gestion (SAFG)', key: 'sum_solde_annuel_frais_gestion', isBold: false, isCalculated: true },
        { label: 'Solde cumulé frais de gestion (SCFG)', key: 'sum_solde_cumule_frais_gestion', isBold: false, isCalculated: true },
        { label: '', key: 'empty_7', isEmpty: true },
        { label: 'Solde d\'opération fin d\'année (SO)', key: 'sum_solde_operation', isBold: true, isCalculated: true }
    ];

    useEffect(() => {
        // Ne rien faire au montage initial
    }, []);

    async function loadConsolidatedIncidences() {
        if (!user || !anneeDebut || !anneeFin) {
            setModalMessage('Veuillez remplir tous les champs');
            setModalVisible(true);
            return;
        }

        setLoading(true);
        try {
            const params = {
                action: 'get_consolidated_by_budget_hypothesis_and_years',
                id_budget: user.id_budget,
                hypothese: 'h' + user.hypothese,
                annee_debut: anneeDebut,
                annee_fin: anneeFin
            };
            
            const res = await axios.post('/api/incidences_financieres_operations.php', qs.stringify(params), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            if (res && res.data && res.data.status === 1) {
                setConsolidatedData(res.data.data || []);
            } else {
                setModalMessage('Erreur lors du chargement des données: ' + (res.data?.message || 'Erreur inconnue'));
                setModalVisible(true);
                setConsolidatedData([]);
            }
        } catch (err) {
            setModalMessage('Erreur lors du chargement des données: ' + (err.response?.data?.message || err.message));
            setModalVisible(true);
            setConsolidatedData([]);
        } finally {
            setLoading(false);
        }
    }

    const formatNumber = (value) => {
        if (!value || isNaN(value)) return '';
        const num = parseFloat(value);
        return num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    };

    return (
        <div>
            <Dialog
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                message={modalMessage}
                callbackDialog={() => {}}
            />
            <div style={{margin: '0 30% 0 30%', padding: 20, backgroundColor: '#f8f9fa', borderRadius: 8, border: '1px solid #e0e0e0', marginBottom: 20}}>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20}}>
                    <div style={{flex: 1}}>
                        <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 8, color: '#666', fontWeight: 600}}>Année de début</p>
                        <input
                            type="text"
                            className='shadow-sm'
                            style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                            placeholder="Ex: 2014"
                            value={anneeDebut}
                            onChange={e => {
                                const value = e.target.value;
                                if (value === '' || /^\d{0,4}$/.test(value)) {
                                    setAnneeDebut(value);
                                }
                            }}
                            maxLength="4"
                        />
                    </div>

                    <div style={{flex: 1}}>
                        <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 8, color: '#666', fontWeight: 600}}>Année de fin</p>
                        <input
                            type="text"
                            className='shadow-sm'
                            style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                            placeholder="Ex: 2030"
                            value={anneeFin}
                            onChange={e => {
                                const value = e.target.value;
                                if (value === '' || /^\d{0,4}$/.test(value)) {
                                    setAnneeFin(value);
                                }
                            }}
                            maxLength="4"
                        />
                    </div>

                    <div style={{flex: 0.8, marginTop: 20}}>
                        <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 8, color: '#666', fontWeight: 600}}></p>
                        <button
                            style={{padding: '10px 20px', borderRadius: 4, border: 'none', backgroundColor: green, color: 'white', cursor: 'pointer', width: '100%'}}
                            onClick={() => {
                                loadConsolidatedIncidences();
                                onValider();
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Chargement...' : 'Afficher'}
                        </button>
                    </div>
                </div>
            </div>

            {consolidatedData.length > 0 && (
                <div>
                    {/* Récapitulatif discret */}
                    <div style={{display: 'flex', gap: 20, marginBottom: 20, padding: '10px 0', borderBottom: '1px solid #e0e0e0', marginLeft: 20, marginRight: 20}}>
                        <div style={{flex: 1}}></div>

                        <div style={{display: 'flex', flexDirection: 'column', gap: 3}}>
                            <p style={{margin: 0, fontSize: 12, color: '#999'}}>Nombre d'années</p>
                            <p style={{margin: 0, fontSize: 14, fontWeight: 'bold', color: purple, textAlign: 'center'}}>
                                {consolidatedData.length}
                            </p>
                        </div>

                        <div style={{display: 'flex', flexDirection: 'column', gap: 3}}>
                            <p style={{margin: 0, fontSize: 12, color: '#999'}}>Hypothèse sélectionnée</p>
                            <p style={{margin: 0, fontSize: 14, fontWeight: 'bold', color: purple, textAlign: 'center'}}>
                               H{user.hypothese.toUpperCase()}
                            </p>
                        </div>

                        {/* <div style={{display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center'}}>
                            <p style={{margin: 0, fontSize: 12, color: '#999'}}>Solde total opération</p>
                            <p style={{margin: 0, fontSize: 14, fontWeight: 'bold', color: purple, textAlign: 'center'}}>
                                {formatNumber(consolidatedData.reduce((sum, row) => sum + (parseFloat(row.sum_solde_operation) || 0), 0))} €
                            </p>
                        </div> */}

                        <div style={{flex: 1}}></div>
                    </div>

                    {/* Tableau */}
                    <div style={{width: '100%', overflowX: 'auto', overflowY: 'hidden', marginBottom: 20, position: 'relative', minWidth: 0, marginLeft: 20, marginRight: 20}} className='rounded-md'>
                        <div style={{display: 'flex', minWidth: 'min-content'}}>
                            {/* Colonne Catégorie - Texte vertical pour catégories */}
                            <div style={{width: 40, minWidth: 40, backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', height: 40, alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', fontWeight: 'bold', minHeight: 40, position: 'sticky', left: 0, top: 0, zIndex: 12}}>
                                </div>

                                {/* Dépenses amortissables - 10 lignes (indices 0-9) */}
                                <div style={{height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 16, fontWeight: 'bold', color: '#666'}}>
                                        Dépenses amortissables
                                    </div>
                                </div>

                                {/* Lignes intermédiaires sans catégorie - indices 10-19 (10 lignes) */}
                                {Array(10).fill(null).map((_, i) => (
                                    <div key={i + 10} style={{height: 40.5, backgroundColor: 'transparent'}}></div>
                                ))}

                                {/* Dépenses - 8 lignes (indices 20-27) */}
                                <div style={{height: 320, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 16, fontWeight: 'bold', color: '#666'}}>
                                        Dépenses
                                    </div>
                                </div>

                                {/* Ligne intermédiaire - indice 31 (1 ligne) */}
                                <div style={{height: 10, backgroundColor: 'transparent'}}></div>

                                {/* Recettes - 8 lignes (indices 32-39) */}
                                <div style={{height: 320, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 16, fontWeight: 'bold', color: '#666'}}>
                                        Recettes
                                    </div>
                                </div>

                                {/* Lignes finales - 7 lignes */}
                                {Array(7).fill(null).map((_, i) => (
                                    <div key={i + 40} style={{height: 40, backgroundColor: 'transparent'}}></div>
                                ))}
                            </div>

                            {/* Colonne Figée - Libellés */}
                            <div style={{minWidth: 200, maxWidth: 300, backgroundColor: 'transparent', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', height: 40, alignItems: 'center', padding: '0 10px', backgroundColor: blue, fontWeight: 'bold', minHeight: 40, position: 'sticky', left: 0, top: 0, zIndex: 12}}>
                                    <p style={{color: 'white', margin: 0, fontSize: 12}}>Libellé (en euro)</p>
                                </div>

                                {/* Lignes */}
                                {fieldsList.map((row, idx) => (
                                    <div key={idx} style={{display: 'flex', height: row.isEmpty ? 12 : 40, alignItems: 'center', padding: '0 8px', borderBottom: row.isEmpty ? 'none' : '1px solid #ddd', backgroundColor: row.isEmpty ? 'transparent' : (row.isCalculated ? '#f0f0f0' : '#ffffff'), minHeight: row.isEmpty ? 12 : 40, position: 'sticky', left: 0, zIndex: 11}}>
                                        <p style={{margin: 0, fontSize: 11, fontWeight: row.isBold ? 'bold' : 'normal'}}>{row.label}</p>
                                    </div>
                                ))}
                            </div>

                            {/* Colonnes de données */}
                            <div style={{display: 'flex', flex: 1}}>
                                {consolidatedData.map((row, yearIdx) => (
                                    <div key={yearIdx} style={{minWidth: 100, display: 'flex', flexDirection: 'column', flexShrink: 0}}>
                                        {/* Header année */}
                                        <div style={{display: 'flex', height: 40, alignItems: 'center', justifyContent: 'center', padding: '0 3px', backgroundColor: blue, fontWeight: 'bold', minHeight: 40, borderBottom: '1px solid #ddd', position: 'sticky', top: 0, zIndex: 10}}>
                                            <p style={{marginTop: 0, color: 'white', fontSize: 12}}>
                                                {row.annee}
                                            </p>
                                        </div>

                                        {/* Données */}
                                        {fieldsList.map((field, idx) => (
                                            <div key={idx} style={{display: 'flex', height: field.isEmpty ? 12 : 40, borderBottom: field.isEmpty ? 'none' : '1px solid #ccc', alignItems: 'center', justifyContent: 'center', minHeight: field.isEmpty ? 12 : 40, backgroundColor: field.isEmpty ? 'transparent' : field.isCalculated ? '#f0f0f0' : '#ffffff', padding: '0 2px', borderLeft: '1px solid #ddd'}}>
                                                {!field.isEmpty && (
                                                    <div style={{width: '100%', height: '100%', fontSize: 11, textAlign: 'center', fontWeight: field.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', color: field.label === 'Solde opération' && parseFloat(row[field.key]) < 0 ? '#FF0000' : '#000', padding: '0 2px'}}>
                                                        {formatNumber(row[field.key])}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default IncidendesFinancieresGlobalOperations;
